import { __awaiter, __generator } from "tslib";
import { getStorage } from '../utils';
export var ZOOM_INFO_KEY = '_ziVisitorInfo';
export function loadZoomInfo(analytics) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var data, reveal;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    data = getStorage(ZOOM_INFO_KEY);
                    if (!data ||
                        data.status !== 'success' ||
                        !data.ziDetails ||
                        !data.ziDetails.website ||
                        ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website)) {
                        return [2 /*return*/];
                    }
                    reveal = data.ziDetails;
                    return [4 /*yield*/, analytics.group(null, {
                            website: reveal.website,
                            intentSource: 'zoominfo',
                            name: reveal.companyName || undefined,
                            country: reveal.country || undefined,
                            industry: reveal.primaryIndustry || undefined,
                            number_of_employees: reveal.employeeCount || undefined,
                            annual_revenue: reveal.revenue || undefined,
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=zoominfo.js.map